
import Vue from "vue";
import CarouselBanner from "@/components/organisms/CarouselBanner.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    CarouselBanner,
  },
  computed: {
    isActivePage() {
      return (nameList) => {
        const { name } = this.$route;
        return nameList.includes(name!);
      };
    },
  },
});

interface Props {}

interface Data {}

interface Computed {
  isActivePage(nameList: string[]): boolean;
}

interface Methods {}
